import React from 'react'

const PostComponent = () => {
  return (
    <div>PostComponent</div>
  )
}

export default PostComponent